// removed by extract-text-webpack-plugin
module.exports = {"ErrorMsg":"ErrorMsg__ErrorMsg__3YRBO","buttonContainer":"ErrorMsg__buttonContainer__1EtSM","okButton":"ErrorMsg__okButton__1DNR9"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/ErrorMsg/ErrorMsg.css
// module id = 603
// module chunks = 0